const ZOOM_MAX_SECTIONS = 13;
const ZOOM_MIN_SECTIONS = 8;

const ZOOM_MAX_ROWS = 15;
const ZOOM_MIN_ROWS = 13;
const ZOOM_SELECTED_ROWS = 14;
const ZOOM_UNSELECTED_ROWS = 13.3;

const ZOOM_MAX_SEATS = 15;
const ZOOM_MIN_SEATS = 13;
const ZOOM_SELECTED_SEATS = 15;

const ZOOM_MAX_FITBOUNDS_SEATS = 13.01;
const ZOOM_MAX_FITBOUNDS_ROWS = 13.01;
const ZOOM_MAX_FITBOUNDS_GASECTIONS = 13.011;

const ZOOM_MIN_GA_SECTIONS = 8;
const ZOOM_MAX_GA_SECTIONS = 15.1;

// eslint-disable-next-line no-magic-numbers
const ZOOM_MAX_ZOOMLEVEL_SECTION = ZOOM_MAX_SECTIONS - 0.01;

const ZOOM_TOOLTIP_BREAKPOINT = 13.5;

// eslint-disable-next-line no-magic-numbers
const OFFSET_SEAT_CENTER_POSITION = [0, 60];
const OFFSET_TOOTIP = 16;

const CLICK_PADDING_WIDTH = 0;
const CLICK_PADDING_HEIGHT = 0;

const FLYTOHOME_DURATION = 900;

/*
 * Changed center coordinates after removing stats header for desktop
 *  TODO: make less magic... works for bills but probably not others? maybe it does based on scale. need to figure it out
 */
// eslint-disable-next-line no-magic-numbers
const MAP_INITAL_CENTER = [0.2, 0.2];

/*
 * Changed map bound box coordinates for desktop after removing stats header
 * TODO: need verify and test using more events.
 */
/* eslint-disable no-magic-numbers */
const MAP_BOUND_BOX_COORDS = [
  [0.3, 0.09],
  [0.77, 0.09],
  [0.77, 0.53],
  [0.3, 0.53],
];

const STOP_ROWS = [
  [13, 5],
  [15, 25],
];

const STOP_SEATS = [
  [13, 3.1],
  [15, 9],
];
/* eslint-enable no-magic-numbers */

export default {
  ZOOM_MAX_SECTIONS,
  ZOOM_MIN_SECTIONS,

  ZOOM_MAX_ROWS,
  ZOOM_MIN_ROWS,
  ZOOM_SELECTED_ROWS,
  ZOOM_UNSELECTED_ROWS,

  ZOOM_MAX_SEATS,
  ZOOM_MIN_SEATS,
  ZOOM_SELECTED_SEATS,

  ZOOM_MAX_FITBOUNDS_SEATS,
  ZOOM_MAX_FITBOUNDS_ROWS,
  ZOOM_MAX_FITBOUNDS_GASECTIONS,

  ZOOM_MIN_GA_SECTIONS,
  ZOOM_MAX_GA_SECTIONS,

  ZOOM_MAX_ZOOMLEVEL_SECTION,

  ZOOM_TOOLTIP_BREAKPOINT,

  STOP_ROWS,
  STOP_SEATS,

  OFFSET_SEAT_CENTER_POSITION,
  OFFSET_TOOTIP,

  CLICK_PADDING_WIDTH,
  CLICK_PADDING_HEIGHT,

  MAP_INITAL_CENTER,
  MAP_BOUND_BOX_COORDS,

  FLYTOHOME_DURATION,
};
